import { Users, Settings, Package } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import manpowerImg from "@/assets/service-manpower.jpg";
import equipmentImg from "@/assets/service-equipment.jpg";
import materialsImg from "@/assets/service-materials.jpg";

const ServicesShowcase = () => {
  const { language } = useLanguage();
  const isAr = language === "ar";

  const items = [
    {
      img: manpowerImg,
      icon: Users,
      title: isAr ? "توريد القوى العاملة" : "MANPOWER SUPPLY",
      desc: isAr
        ? "قوى عاملة ماهرة وشبه ماهرة وغير ماهرة لجميع الصناعات"
        : "Skilled, Semi-skilled & Unskilled Workforce for all Industries",
    },
    {
      img: equipmentImg,
      icon: Settings,
      title: isAr ? "توريد المعدات" : "EQUIPMENT SUPPLY",
      desc: isAr
        ? "معدات موثوقة للبناء والصناعة ومشاريع التوقف"
        : "Reliable Equipment for Construction, Industrial & Shutdown Projects",
    },
    {
      img: materialsImg,
      icon: Package,
      title: isAr ? "توريد المواد" : "MATERIAL SUPPLY",
      desc: isAr
        ? "مواد صناعية وإنشائية حسب متطلبات المشروع"
        : "Industrial & Construction Materials as per Project Requirement",
    },
  ];

  return (
    <section className="bg-background py-12 lg:py-16">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((it) => (
            <article
              key={it.title}
              className="group rounded-xl overflow-hidden shadow-elegant ring-1 ring-border bg-card"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={it.img}
                  alt={it.title}
                  loading="lazy"
                  width={1024}
                  height={768}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="bg-primary-darker text-primary-foreground p-5 flex items-start gap-4">
                <span className="w-12 h-12 shrink-0 rounded-full bg-accent/15 border border-accent/40 flex items-center justify-center">
                  <it.icon className="w-6 h-6 text-accent" />
                </span>
                <div>
                  <h3 className="font-montserrat font-bold text-lg uppercase tracking-wide mb-1">
                    {it.title}
                  </h3>
                  <p className="text-sm text-primary-foreground/80 leading-relaxed">{it.desc}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesShowcase;
